export default __webpack_public_path__ + "static/media/g-xl-1.520dfb70.png";